import { render } from "./input-box.vue?vue&type=template&id=1dccd195&scoped=true"
import script from "./input-box.vue?vue&type=script&lang=js"
export * from "./input-box.vue?vue&type=script&lang=js"

import "./input-box.vue?vue&type=style&index=0&id=1dccd195&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dccd195"]])

export default __exports__